import localStorage from 'local-storage';

function generateOrderIdKey(orderId) {
  return `vp_orderPlaced_${orderId}`;
}

export function getOrderDataFromLocalStorage(orderId) {
  const orderIdKey = generateOrderIdKey(orderId);
  return localStorage.get(orderIdKey);
}

export function removeOrderDataFromLocalStorage(orderId) {
  const orderIdKey = generateOrderIdKey(orderId);
  localStorage.remove(orderIdKey);
}
